import apiService from '../apiService';
import { handleHttpError } from '../errorHandler';

// 取得選項列表
export const getOptions = async (params = {}) => {
    try {
        const response = await apiService.GET('api/admin/options', params);
        // 回傳完整物件，包含 status/page/page_size/total/data
        return response;
    } catch (error) {
        throw error;
    }
};

/**
 * 批次取得多個類型的選項
 * @param {Object} payload
 * @param {number[]} payload.type_ids - 類型 ID 陣列
 * @param {number} [payload.class] - 資產負債類型：0 = 資產，1 = 負債
 * @returns {Promise<Object>} 回傳格式：{ status: 1, data: { [type_id]: [options...] } }
 */
export const getOptionsBatch = async (payload) => {
    try {
        const url = '/api/admin/finance/options/batch';
        const response = await apiService.POST(url, payload);
        return response;
    } catch (error) {
        throw handleHttpError(error, url, 'POST');
    }
};

// 新增選項資料
export const createOption = async (data) => {
    try {
        const response = await apiService.POST('api/admin/options', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 更新選項資料
export const updateOption = async (id, data) => {
    try {
        const response = await apiService.PUT(`api/admin/options/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 刪除選項資料
export const deleteOption = async (id) => {
    try {
        const response = await apiService.DELETE(`api/admin/options/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
